import * as React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Paper from '@mui/material/Paper'
import {visuallyHidden} from '@mui/utils'
import {useAlert, useHelper, useHttpClient} from '../../../../modules/services/Bundle'
import {EnumTipoEnviarAvaliacao, RequestMethod} from '../../../../modules/services/core/_enums'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import {IconButton} from '@mui/material'
import {ModalCarregarDescricoes} from '.././partials/ModalCarregarDescricoes'
import {FileModel} from '../../../../modules/services/core/_models'

interface Data {
  Id: number
  Nome: string
  Email: string
  NomeCargo: string
  AvaliadorNaDescricao: boolean
}

interface Column {
  id: keyof Data
  label: string
  minWidth?: number
  align?: 'center'
  format?: (value: number) => string
}

interface ModalAvaliadoresProps {
  IdDescricao: number
  IdsDescricao?: readonly number[]
  TipoRequest?: number
  AbrirModal: boolean
  SetAbrirModal: (bool: boolean) => void
  atualizarDados?: Function 
  idEmpresa?: number | null
}

const columns: readonly Column[] = [
  {
    id: 'Nome',
    label: 'COLABORADOR',
  },
  {
    id: 'Email',
    label: 'EMAIL',
  },
  {
    id: 'NomeCargo',
    label: 'CARGO',
    align: 'center',
  },
  {
    id: 'AvaliadorNaDescricao',
    label: 'AVALIADOR NESTA DESCRIÇÃO',
    align: 'center',
  },
]

function createData(
  Id: number,
  Nome: string,
  Email: string,
  NomeCargo: string,
  AvaliadorNaDescricao: boolean
): Data {
  return {Id, Nome, Email, NomeCargo, AvaliadorNaDescricao}
}

type Order = 'asc' | 'desc'

interface EnhancedTableProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void
  order: Order
  orderBy: string
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const {order, orderBy, onRequestSort} = props
  const createSortHandler = (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow className='table-header'>
        {columns.map((columns) => (
          <TableCell
            className='table-cell'
            key={columns.id}
            align={columns.align ? columns.align : 'left'}
          >
            <TableSortLabel
              className='fw-bolder'
              active={orderBy === columns.id}
              direction={orderBy === columns.id ? order : 'asc'}
              onClick={createSortHandler(columns.id)}
            >
              {columns.label}
              {orderBy === columns.id ? (
                <Box component='span' sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        {/* <TableCell className='table-cell fw-bolder' align='center' style={{minWidth: '150px'}}>
          AÇÕES
        </TableCell> */}
      </TableRow>
    </TableHead>
  )
}

const ModalAvaliadores = ({
  IdDescricao,
  IdsDescricao,
  TipoRequest,
  AbrirModal,
  SetAbrirModal,
  atualizarDados,
  idEmpresa = null
}: ModalAvaliadoresProps) => {
  const httpClient = useHttpClient()
  const navigate = useNavigate()
  const alert = useAlert()
  const helper = useHelper()
  const [order, setOrder] = React.useState<Order>('asc')
  const [orderBy, setOrderBy] = React.useState<keyof Data>('AvaliadorNaDescricao')
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(5)
  const [total, setTotal] = React.useState(0)
  const [rows, setRows] = React.useState<Data[]>([])

  const onClickBuscar = (search: string) => {
    resquestTable(page, orderBy, order, rowsPerPage, search, true);
  }

  const resquestTable = (
    pageRq: number,
    orderByRq: string,
    orderRq: string,
    rowsPerPageRq: number,
    search: any = null,
    block: boolean = false,
  ) => {
    httpClient
      .request({
        method: RequestMethod.POST,
        endpoint: '/Gerenciamento/Usuario/ListarAvaliadores',
        blockFree: block,
        data: {
          Order: orderRq,
          OrderBy: orderByRq,
          Page: pageRq,
          RowsPerPage: rowsPerPageRq,
          Search: search
        },
        queryObject: {
          idDescricao: IdDescricao,
          idEmpresa: idEmpresa ?? 0
        },
      })
      .then((result) => {
        const newRows = result.payload.data.map((data: Data) => {
          return createData(data.Id, data.Nome, data.Email, data.NomeCargo, data.AvaliadorNaDescricao)
        })
        setRows([...newRows])
        setTotal(result.payload.total)
      })
  }

  React.useEffect(() => {
    obterDadosTabela()
  }, [])

  const obterDadosTabela = () => {
    resquestTable(page, orderBy, order, rowsPerPage)
  }

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof Data) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
    resquestTable(page, property, isAsc ? 'desc' : 'asc', rowsPerPage)
  }

  const handleChangePage = (event: unknown, newPage: number) => {
    resquestTable(newPage, orderBy, order, rowsPerPage)
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    resquestTable(page, orderBy, order, parseInt(event.target.value, 10))
    setPage(0)
  }

  const emptyRows = rows.length

  return (
    <div className={`modal show fade`} tabIndex={-1} id='kt_modal_1' style={{display: 'block'}}>
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Vincular Avaliadores</h5>
            <div
              onClick={() => SetAbrirModal(false)}
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Fechar'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            {/* begin::Content */}
            <div className='row'>

              {/* begin::Input group */}
              <div className='mb-2 col-lg-6'>
                <input 
                  type='text'
                  onChange={e => onClickBuscar(e.target.value)} 
                  placeholder='Pesquisar (Nome, E-mail ou CPF)' 
                  className={`form-control form-control-lg form-control-solid`}
                ></input>
              </div>
              {/* end::Input group */}
            </div>
            {/* end::Content */}
            <Box sx={{width: '100%'}}>
              <Paper className='table-border ' sx={{width: '100%', mb: 2}}>
                <TableContainer>
                  <Table className='table-header' sx={{minWidth: 750}} aria-labelledby='tableTitle'>
                    <EnhancedTableHead
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                    />
                    <TableBody>
                      {rows.map((row, index) => {
                        return (
                          <TableRow
                            className='table-row'
                            hover
                            tabIndex={-1}
                            key={index}
                            sx={{cursor: 'pointer'}}
                          >
                            <TableCell className='table-cell' align='left'>
                              {row.Nome}
                            </TableCell>
                            <TableCell className='table-cell' align='left'>
                              {row.Email}
                            </TableCell>
                            <TableCell className='table-cell' align='center'>
                              {row.NomeCargo}
                            </TableCell>
                            <TableCell className='table-cell' align='center'>
                              <div className="d-flex flex-center">
                                <div className="form-check form-switch form-check-custom form-check-solid">
                                    <input 
                                    checked={row.AvaliadorNaDescricao} 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    id="flexSwitchDefault"
                                    onClick={(e) => {
                                      alert.createDialog({
                                        html: `Realmente deseja ${
                                          row.AvaliadorNaDescricao ? 'remover' : 'adicionar'
                                        } este avaliador?`,
                                        confirmAction: async () => {                                          
                                          httpClient
                                            .request({
                                              method: RequestMethod.PUT,
                                              endpoint: '/Gerenciamento/Usuario/AdicionarRemoverAvaliadorDescricao',
                                              queryObject: {
                                                idUsuario: row.Id,
                                                idDescricao: IdDescricao,
                                              },
                                            })
                                            .then((response) => {
                                              if (response.success) obterDadosTabela()
                                            })
                                        },
                                        notConfirmAction: () => {
                                          const target = e.target as HTMLInputElement;
                                          target.checked = row.AvaliadorNaDescricao;
                                        },
                                      })
                                    }}
                                    />
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        )
                      })}
                      {emptyRows === 0 && (
                        <TableRow>
                          <TableCell className='table-cell text-center' colSpan={6}>
                            Nenhum registro encontrado
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  className='table-footer'
                  labelRowsPerPage='linhas por página'
                  rowsPerPageOptions={[10, 25]}
                  component='div'
                  count={total}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Box>
          </div>
          <div className='modal-footer'>            
            <button className='btn btn-secondary' onClick={() => SetAbrirModal(false)}>
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ModalAvaliadores}
